import request from "@/util/http";
/**
 * 列表
 */
export function member_review_list(query) {
	return request({
		url: '/goods/shop/review/member_review_list',
		method: 'get',
		params: query,
	})
}

/**
 * 列表
 */
export function goods_review_list(query) {
	return request({
		url: '/goods/shop/review/goods_review_list',
		method: 'get',
		params: query,
	})
}

/**
 * 列表
 */
export function list_json(query) {
	return request({
		url: '/goods/shop/review/list_json',
		method: 'get',
		params: query,
	})
}

/**
 * 发表
 */
export function add(id) {
	return request({
		url: '/goods/shop/review/add',
		method: 'get',
		params: params,
	})
}

/**
 * 保存
 */
export function save(data, params) {
	return request({
		url: '/goods/shop/review/save',
		method: 'post',
		data: data,
		params: params,
	})
}

/**
 * 删除
 */
export function del(params) {
	return request({
		url: '/goods/shop/review/delete',
		method: 'delete',
		params: params,
	})
}

// 888888888888888888888888888888888888888888888888888888888888888888 ↓

/**
 * 列表
 */
// @GetMapping(path = "/list", produces = MediaType.APPLICATION_JSON_VALUE)
// @JsonView(BaseEntity.BaseView.class)
// public ResponseEntity<?> list(String goodsId, Integer pageNumber) {
// export function list(query) {
//   return request({
// 	url: '/order/shop/order/check_sku',
// 	method: 'get',
// 	params: query,
// 	headers: app.globalData.headers,
//   })
// }

/**
 * 详情
 */
export function detail(query) {
	return request({
		url: '/goods/shop/review/detail',
		method: 'get',
		params: query,
	})
}

/**
 * 获取当前会员E-mail
 */
export function email() {
	return request({
		url: '/goods/shop/review/email',
		method: 'get',
	})
}

/**
 * 保存
 */
export function save_sku(query) {
	return request({
		url: '/goods/shop/review/save_sku',
		method: 'post',
		params: query,
	})
}


// module.exports = {
// 	goods_review_list,
// 	list_json,
// 	add,
// 	save,
// 	del,
// 	detail,
// 	email,
// 	save_sku,
// 	member_review_list,
// }
